/**
 * Created by tmorone on 5/10/2016.
 */

var Marionette = require('backbone.marionette');

module.exports = Marionette.LayoutView.extend({
    template: require('../templates/ServerDown.html'),
});
